import { IDeepCopy } from "@common/interfaces/i-deep-copy";
import { Util } from "@common/utils/util";

export class Table implements IDeepCopy<Table> {
    public data: Array<Array<any>> = [];
    public colMetadata: Array<{ [id: string]: any }> = [];
    totalCost: number = 0;

    public clear() {
        this.data = [];
    }

    public updateFrom(newTable: Table) {
        let row = 0;
        if (!newTable.data)
            return;
        while (row < newTable.data.length) {
            if (row >= this.data.length) {
                let newRow = [];
                for (let col = 0; col < newTable.data[row].length; col++) {
                    newRow.push(newTable.data[row][col]);
                }
                this.data.push(newRow);
            } else {
                for (let col = 0; col < newTable.data[row].length; col++) {
                    if (this.data[row][col] != newTable.data[row][col]) this.data[row][col] = newTable.data[row][col];
                }
            }
            row++;
        }
        this.data.splice(row, this.data.length - row);
        this.addEmptyRowIfNeeded();
    }

    public hasValues(): boolean {
        if (this.data.length > 0) {
            for (let i = 0; i < this.data[0].length; i++) {
                if (this.data[0][i]) return true;
            }
            return false;
        }
        return false;
    }

    public set(row: number, col: number, value: any) {
        if (typeof value === "string") value = value.replace(/[\u00A0]/g, " ");
        if (!this.data[row]) {
            this.data[row] = [];
            for (let i = 0; i < this.colMetadata.length; i++) this.data[row].push(null);
        }
        this.data[row][col] = value;
        this.addEmptyRowIfNeeded();
    }

    public get(row: number, col: number) {
        if (!this.data[row]) return null;
        return this.data[row][col];
    }

    public addEmptyRowIfNeeded() {
        if (this.colMetadata.length > 0) {
            let shouldAddRow = false;
            if (this.data.length > 0) {
                for (let col = 0; col < this.colMetadata.length; col++) {
                    if (this.data[this.data.length - 1][col]) {
                        shouldAddRow = true;
                        break;
                    }
                }
            } else {
                shouldAddRow = true;
            }
            if (shouldAddRow) {
                this.data.push([]);
                for (let col = 0; col < this.colMetadata.length; col++) {
                    this.data[this.data.length - 1].push(null);
                }
            }
        }
    }

    public getRowCount(): number {
        return this.data.length;
    }

    public getColCount(row: number): number {
        if (this.data[row] || (this.data[row].length == 0)) return 0;
        return this.data[row].length;
    }

    public equals(target: Table) {
        if (!target) {
            return (this.data.length == 0);
        }
        for (let i = 0; i < this.getRowCount(); i++) {
            for (let j = 0; j < this.getColCount(i); j++) {
                if (this.get(i, j) != target.get(i, j)) {
                    return false;
                }
            }
        }
        for (let i = 0; i < target.getRowCount(); i++) {
            for (let j = 0; j < target.getColCount(i); j++) {
                if (target.get(i, j) != this.get(i, j)) {
                    return false;
                }
            }
        }
        return false;
    }

    public calculateCost(columns: { [id: string]: any }) {
        this.totalCost = 0;

        for (let col in columns) {
            if (columns[col].validation.toUpperCase() == 'TEXT') {
                for (let row of this.data) {
                    let cost = parseFloat(row[col]);
                    if (cost && !Number.isNaN(cost)) this.totalCost += cost;
                }
            }
        }
    }

    public deepCopy(): Table {
        let ret = new Table();
        ret.data = Util.deepCopy(this.data);
        ret.colMetadata = Util.deepCopy(this.colMetadata);
        ret.totalCost = Util.deepCopy(this.totalCost);
        return ret;
    }
}
